import cx from "classnames";
import React from "react";
import Image from "./Image";
import Section from "../Section";
import UserContext from "../../utils/context";

const Header: React.FC = (): React.ReactElement => {
  const renderImage = React.useCallback((): React.ReactElement => {
    const date = new Date();
    const day = date.getDay();
    let filename;
    switch (day) {
      // Sunday
      // Tuesday
      // Thursday
      // Saturday
      case 0:
      case 2:
      case 4:
      case 6:
        filename = "headshot-one";
        break;
      // Monday
      // Wednesday
      // Friday
      case 1:
      case 3:
      case 5:
        filename = "headshot-one";
        break;
      default:
        filename = "headshot-one";
        break;
    }
    return <Image filename={filename} />;
  }, []);

  const value = React.useContext(UserContext);

  return (
    <Section className="u-background-color-primary" id="Header">
      <div
        className={cx([
          "u-flex",
          "u-flex-column",
          "u-margin-bottom-negative-0point875rem",
          "u-margin-top-negative-0point875rem",
        ])}
      >
        <div
          className={cx([
            "u-padding-bottom-0point875rem",
            "u-padding-top-0point875rem",
          ])}
        >
          <div
            className={cx([
              "u-flex",
              "u-flex-column",
              "u-align-items-center",
              "u-justify-content-center",
              "u-padding-left-0point875rem",
              "u-padding-right-0point875rem",
            ])}
          >
            <p
              className={cx([
                "u-color-secondary",
                "u-font-size-xl",
                "u-line-height-s",
                "u-margin-bottom-3xs",
                "u-margin-top-xs",
                "u-text-bold",
                "u-text-center",
              ])}
            >
              {value.name.toUpperCase()}
            </p>
            <p
              className={cx([
                "u-color-secondary",
                "u-font-size-m",
                "u-line-height-s",
                "u-margin-bottom-xs",
                "u-margin-top-3xs",
                "u-text-center",
                "u-text-normal",
              ])}
            >
              Strategic Learning Leader
            </p>
            <div>{renderImage()}</div>
          </div>
        </div>
      </div>
    </Section>
  );
};

export default React.memo(Header);
